import React from 'react';
import './SzCenter.css';
import { Carousel, Form } from 'antd';
import { GetExhibitionBanner } from "../../api/api";
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux"
import actions from "../../store/actions"
import VlecImg from "../../component/VlecImg"



let img2 = require("../../static/images/photo-01.png");

class InnovationCenter extends React.Component {
    state = {
        GetExhibitionBanner: [],
    }

    componentWillMount() {

    }
    componentDidMount() {
        /*展厅接口*/
        GetExhibitionBanner('SZ').then((response) => {
            let data = response.DataResult;
            this.setState({
                GetExhibitionBanner: data
            });
        });
    }

    render() {
        const centertitle1 = this.props.local === 'en' ?
            "Smarter technology for all" : "智能，为变革赋能";
        const centertitle3_1 = this.props.local === 'en' ?
            <span>Located at Lenovo Houhai Center, Nanshan District, Shenzhen, Lenovo Future Center was officially put into operation in March 2023, covering an area of 2,500 m<sup>2</sup>.</span>
            : 
            <span>联想深圳未来中心位于深圳市南山区联想后海中心，于2023年3月正式开放，占地 2500 m<sup>2</sup>。深圳是中国改革开放的窗口、粤港澳大湾区的核心引擎，联想扎根深圳30多年，与深圳的发展同频共振。</span>;
        const centertitle3_2 = this.props.local === 'en' ?
            <span>As the window of China's reform and opening up, Shenzhen now becomes the engine of the Guangdong–Hong Kong–Macao Greater Bay Area.</span>
            : 
            <span>联想深圳未来中心绽放于科技之城，围绕新IT架构、制造、教育、金融、电信等行业场景和应用案例，呈现了联想赋能千行百业、推进智能化转型的最新实践成果。</span>;
        const centertitle3_3 = this.props.local === 'en' ?
            <span>The innovation ecosystem of this city offers great opportunity for Lenovo Future Center to demonstrate Lenovo’s capabilities of empowering customers in their digital transformation. The center offers a brand-new presentation of Lenovo’s New IT architecture, and use cases of verticals including smart manufacturing, education, finance and telecommunication.</span>
            : 
            <span></span>;

        const makedes = this.props.local === 'en' ?
            <span>Based on Lenovo’s practices in smart manufacturing, this area demonstrates Lenovo’s innovation in the whole value chain of manufacturing including <span className="quot">&quot;</span>Research, Supply Chain, Production, Sales and Service<span className="quot">&quot;</span>. Cases of Lenovo's global supply chain management, digital product development and production, and industrial metaverse solutions are presented.</span>
            : 
            <span>智能制造展区围绕联想在智能制造领域的实践，全面地展现了联想研产供销服（研发、供应链、营销、销售、服务）全价值链环节的模式创新。联想独特的全球供应链、数字化研发生产和工业元宇宙平台的各个案例都展现于此。</span>;
        const f1Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,1<sup>st</sup>floor<br />— 3,000 m<sup>2</sup></h4> : <h4>联想未来中心1层<br />——3000 m<sup>2</sup></h4>;
        const f2Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,2<sup>nd</sup>floor<br />— 2,000 m<sup>2</sup></h4> : <h4>联想未来中心2层<br />——2000 m<sup>2</sup></h4>;
        const f3Title = this.props.local === 'en' ? <h4 style={{ width: "290px" }}>Lenovo Future Center,3<sup>rd</sup>floor<br />— 1,000 m<sup>2</sup></h4> : <h4>联想未来中心3层<br />——1000 m<sup>2</sup></h4>;
        return (<div>
            {/*轮播图片*/}
            <div>
                <Carousel autoplay>
                    {this.state.GetExhibitionBanner.map((item) => {
                        return <div key={item.ID}>
                            {/* <a href={item.URL}> */}
                            <VlecImg src={item.ImagePath} alt="" />
                            {/* </a> */}

                        </div>
                    })}
                </Carousel>
            </div>
            <div className="indexDiv Innovation_Con">
                <div className="center">
                    <div className="titleH4">
                        <h4>
                            {centertitle1}
                        </h4>
                        <p className="shsmartP">
                            {centertitle3_1}
                            <br /><span></span><br/>
                            {centertitle3_2}
                            <br /><span></span><br/>
                            {centertitle3_3}
                        </p>

                    </div>
                </div>
                {/*下面的图片*/}
                {/* <div className="center centerDiv">
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce01.png" alt="" />
                            </dt>
                            <dd>
                                {f1Title}
                                <p><FormattedMessage id="intl-center-f1Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f1Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce02.png" alt="" />
                            </dt>
                            <dd>
                                {f2Title}
                                <p><FormattedMessage id="intl-center-f2Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f2Des" /></p>
                    </div>
                    <div className="centerBock">
                        <dl>
                            <dt>
                                <img src="images/introduce03.png" alt="" />
                            </dt>
                            <dd>
                                {f3Title}
                                <p><FormattedMessage id="intl-center-f3Title2" /></p>
                            </dd>
                        </dl>
                        <p><FormattedMessage id="intl-center-f3Des" /></p>
                    </div>
                </div> */}
                <div className="imgDiv">
                    <ul className="shimgBock">
                        <li>
                            <img src="images/sz/it.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-szcenter-ittitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-szcenter-itdes1" />
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-szcenter-itdes2" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sz/make.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-szcenter-maketitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        {makedes}
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sz/education.jpg" alt="" />
                            <div className="imgHover">
                                <h4> <FormattedMessage id="intl-szcenter-educationtitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-szcenter-educationdes1" />
                                        <br></br>
                                        <FormattedMessage id="intl-szcenter-educationdes2" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sz/ESG.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-szcenter-ESGtitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-szcenter-ESGdes1" />
                                    </p>
                                    <p>
                                        <FormattedMessage id="intl-szcenter-ESGdes2" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sz/city.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-szcenter-citytitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-szcenter-citydes" />
                                    </p>
                                </div>

                            </div>
                        </li>
                        <li>
                            <img src="images/sz/finance.jpg" alt="" />
                            <div className="imgHover">
                                <h4><FormattedMessage id="intl-szcenter-financetitle" /></h4>
                                <div className="imgFone">
                                    <p>
                                        <FormattedMessage id="intl-szcenter-financedes" />
                                    </p>
                                </div>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>)
    }
};
export default connect(state => ({ ...state.Language }), actions.Language)(InnovationCenter)


// WEBPACK FOOTER //
// ./src/containers/SzCenter/SzCenter.js